import { FC } from "react";
import { useHorizontalScroll, ScrollDirection } from "@/domains/react/useHorizontalScroll";
import { ScrollButton } from "@/components/horizontal-scroll/ScrollButton";
import { HorizontalScrollStyledScrollable } from "@/components/horizontal-scroll/horizontal-scroll.styles";
import { HorizontalScrollStyledWrapper } from "@/components/horizontal-scroll/horizontal-scroll.styles";
import { HorizontalScrollProps } from "@/components/horizontal-scroll/horizontal-scroll.types";

export const HorizontalScroll: FC<HorizontalScrollProps> = ({
  children,
  className,
  scrollButtonClassName,
  variant = "standard",
  ...props
}) => {
  const {
    scrollContainerRef,
    scrollState,
    handleScroll,
    startScrolling,
    stopScrolling,
    scrollForDuration,
  } = useHorizontalScroll();

  return (
    <HorizontalScrollStyledWrapper>
      <ScrollButton
        direction={ScrollDirection.Left}
        scrollState={scrollState}
        startScrolling={startScrolling}
        stopScrolling={stopScrolling}
        scrollForDuration={scrollForDuration}
        variant={variant}
        scrollButtonClassName={scrollButtonClassName}
      />
      <HorizontalScrollStyledScrollable
        {...props}
        className={className}
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        {children}
      </HorizontalScrollStyledScrollable>
      <ScrollButton
        direction={ScrollDirection.Right}
        scrollState={scrollState}
        startScrolling={startScrolling}
        stopScrolling={stopScrolling}
        scrollForDuration={scrollForDuration}
        variant={variant}
        scrollButtonClassName={scrollButtonClassName}
      />
    </HorizontalScrollStyledWrapper>
  );
};
